import React from 'react';
import {
  ChiTietDon,
  QuaTrinhXuLy,
  KetQuaHoanThanhGiaiQuyetDonCanBo,
  KetQuaLapDuThaoCanBo,
  KetQuaXuLyDon,
  KetQuaCanBoKiemTraDeXuat,
  KetQuaLapDuThaoDonKhieuNaiCanBo,
  KetQuaTheoDoiThucHien
} from 'modules/giai-quyet-don/subView';
import { getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import {ContainerFileDinhKem} from 'components/upload';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { ShowIf } from 'components/utils';
import { Link, browserHistory } from 'react-router';
import moment from 'moment';
import { GiaiQuyetDonThu, LetterProcessingWorkFlow, Letter, Reception } from 'api';
import {TextArea} from 'components/tt-forms/common';
import {ConfirmDialog} from 'modules/dialog';
import { CheckViewPermission } from 'modules/login/CheckPermission';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';
const buocGiaiQuyet = 'BO_SUNG_SAU_KHI_LUU_HO_SO'

class BoSungThongTin extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      id: this.props.params.id,
      nameComponent: '',
      isOpen: true,
      backConfirm: false,
      hasChange: false,
      isSubmit: false,
      hideKetQuaXuLyDon: false,
      showAttachFile: false,
      onSave: true,
      typeComponent: '',
      data: {},
      dataLoaiNguoiDD: [],
      dataLoaiDonThu: [],
      dataLoaiDoiTuong: [],
      dataLichSuQuaTrinhXuLy: [],
      dataDonViTTXM: [],
      dsTepDinhKem: [],
      dataGiaiQuyetDon: [],
      coQuanQuanLyNguoiDung: [],
      dataNextStates: '',
      canBoXuLyChiDinh: '',
      yKienGiaiQuyet: '',
      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',
      ngayHetHanGiaiQuyet: '',
      noiDungBoSungHoSo: '',
      dataLichSuGiaiQuyet: [],
      loaiDon: 'DON_KHIEU_NAI',
      dataKetQuaXuLyDon: {},
      donViGiaoTTXM: {},
      taiLieuDinhChi: {},
      listTaiLieuVanThuKiemTraDeXuat: [],
      dataKiemTraDeXuat: [],
      hideQuaTrinhXuLy: false,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuBoSungHoSo: []
    }
  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        coQuanQuanLyNguoiDung: {
          ...this.state.coQuanQuanLyNguoiDung,
          id: userInfo.coQuanQuanLyId,
          ten: userInfo.tenCoQuanQuanLy
        },
        donViGiaoTTXM: userInfo.donViId
      });
    }
  }

  componentDidMount() {
    this.getDonDetail();
    this.getQuyTrinhXuLyHistory();
    if (window.debug) {
      console.log('modules/bo-sung-thong-tin/BoSungThongTin');
    }
  }

  getQuyTrinhXuLyHistory() {
    LetterProcessingWorkFlow.actions.getQuyTrinhXuLyHistory.request({ donId: this.state.id }).then(res => {
      if(res.data._embedded) {
        this.setState({ dataLichSuQuaTrinhXuLy: res.data ? res.data._embedded.lichSuQuaTrinhXuLies : [] });
      }
    });
  }

  getDonDetail() {
    let params = {
      id: this.state.id
    }
    Letter.actions.getDonDetail.request(params).then(res => {
      if (res.data) {
        if (CheckViewPermission(res.data)) {
          Reception.actions.getDonInfo.request({ id: this.state.id }).then(res1 => {
            if (res1.data) {
              res.data = {...res.data, ...res1.data};
            }
            let dataKetQuaXuLyDon = {
              thamQuyenGiaiQuyet: res.data.thamQuyenGiaiQuyetInfo ? res.data.thamQuyenGiaiQuyetInfo.ten : ''
            }
            this.setState({
              data: res.data,
              loaiDon: res.data.loaiDon,
              dataKetQuaXuLyDon: dataKetQuaXuLyDon,
              listTaiLieuVanThuBoSungHoSo: res.data.listTaiLieuVanThuBoSungHoSo,
            }, () => {
              this.getLichSuGiaiQuyetDon(this.state.id);
            });
          });
        } else {
          browserHistory.push('/page-403');
        }

      }
    });
  }

  getLichSuGiaiQuyetDon(id) {
    let params = {
      id: id
    }
    GiaiQuyetDonThu.actions.getLichSuGiaiQuyetDon.request(params).then(res => {
      let dataKQXLD = {...this.state.dataKetQuaXuLyDon};
      dataKQXLD.yKienXuLy = res.data.thongTinGiaiQuyetDonInfo ? res.data.thongTinGiaiQuyetDonInfo.yKienXuLyDon : '';
      dataKQXLD.phongBanGiaiQuyet = res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.ten : '';
      this.setState({
        dataLichSuGiaiQuyet: res.data,
        nameComponent: res.data.nextFormInfo ? res.data.nextFormInfo.alias : '',
        typeComponent: res.data.nextStateInfo ? res.data.nextStateInfo.type : '',
        dataKetQuaXuLyDon: dataKQXLD,
        dataKiemTraDeXuat: res.data.thongTinYeuCauKiemTraDeXuatInfo,
        noiDungBoSungHoSo: res.data.thongTinGiaiQuyetDonInfo.noiDungBoSungHoSo,
        showAttachFile: true
      },()=> {
        this.checkHideKetQuaXuLyDon();
      });
    });
  }

  renderWorkFollow() {
    switch (this.state.nameComponent) {
      case 'TruongPhongNhanDuThaoVaGiaoViec':
        return (
          <KetQuaLapDuThaoDonKhieuNaiCanBo
          nhanDuThao={true}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
          listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
          {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          loaiDon={this.state.loaiDon}
          donInfo = {this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          boSungThongTin={true}
        />
        )
      case 'TruongPhongNhanBaoCaoTTXMVaGiaoViec':
        if (this.state.typeComponent == 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO') {
          return(
            <KetQuaLapDuThaoDonKhieuNaiCanBo
              listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
              listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
              {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              loaiDon={this.state.loaiDon}
              donInfo = {this.state.data}
              thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
              boSungThongTin={true}
            />
          )
        }
      break;
      case 'CanBoGiaiQuyetDonAction':
        return(
          <KetQuaHoanThanhGiaiQuyetDonCanBo
          {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
          listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
          loaiDon={this.state.loaiDon}
          donInfo = {this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          boSungThongTin={true}/>
        )
      case 'CanBoGiaiQuyetDonKhongQuyTrinh':
        return(
          <KetQuaHoanThanhGiaiQuyetDonCanBo
          {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonView}
          listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
          loaiDon={this.state.loaiDon}
          donInfo = {this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          boSungThongTin={true}/>
        )
      case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoKhongQuyTrinh':
      case 'CanBoGiaiQuyetDonXuLySauKhiNhanDuThaoAction':
        return (
          <KetQuaLapDuThaoDonKhieuNaiCanBo
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
          listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
          {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          nhanDuThao={true}
          donInfo = {this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          loaiDon={this.state.loaiDon}
          boSungThongTin={true}
          />
        )
      case 'CanBoGiaiQuyetDonLapDuThaoKhongQuyTrinh':
      case 'CanBoGiaiQuyetDonLapDuThaoAction':
        if (this.state.loaiDon == 'DON_KHIEU_NAI') {
          return (
            <KetQuaLapDuThaoDonKhieuNaiCanBo
            listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
            listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
            {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            donInfo = {this.state.data}
            thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            loaiDon={this.state.loaiDon}
            boSungThongTin={true}
            />
          )
        } else {
          return (
            <KetQuaLapDuThaoCanBo
            listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
            listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
            {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            donInfo = {this.state.data}
            thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            loaiDon={this.state.loaiDon}
            boSungThongTin={true}
            />
          )
        }
      case 'canBoKiemTraDeXuatKhongQuyTrinh':
      case 'canBoKiemTraDeXuat':
        return (
          <KetQuaCanBoKiemTraDeXuat
          listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuKiemTraDeXuat}
          dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
          donInfo = {this.state.data}
          thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
          thongTinYeuCauKiemTraDeXuat = {this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
          listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
          boSungThongTin={true}
          />
        )
      case 'canBoTDTHKhongQuyTrinh':
      case 'TruongPhongTDTHAction':
      case 'CanBoTDTHAction':
        return (
          <KetQuaTheoDoiThucHien
            listTaiLieuVanThuGiaiQuyetDon={this.state.data.listTaiLieuVanThuGiaiQuyetDonSauKhiTTXMView}
            dataKiemTraDeXuat = {this.state.dataKiemTraDeXuat}
            {...this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            loaiDon={this.state.loaiDon}
            donInfo = {this.state.data}
            thongTinGQD = {this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo}
            listTaiLieuVanThuBoSungHoSo={this.state.data.listTaiLieuVanThuBoSungHoSo}
            thongTinYeuCauKiemTraDeXuat = {this.state.dataLichSuGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo}
            boSungThongTin={true}
          />
        )
    }
  }

  checkHideKetQuaXuLyDon() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (this.state.data.donViThamTraXacMinhInfo && this.state.data.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
      this.setState({
        hideKetQuaXuLyDon: true
      })
    }
    if (this.state.nameComponent == 'canBoKiemTraDeXuat' ||
      this.state.nameComponent == 'canBoKiemTraDeXuatKhongQuyTrinh' ||
      this.state.nameComponent == 'truongPhongKiemTraDeXuat' ||
      this.state.nameComponent == 'canBoTDTHKhongQuyTrinh' ||
      this.state.nameComponent == 'TruongPhongTDTHAction' ||
      this.state.nameComponent == 'CanBoTDTHAction') {
      this.setState({
        hideKetQuaXuLyDon: true
      })
    }
    this.setState({
      formGiaiQuyet : this.renderWorkFollow()
    })
  }

  onFileRemove(id, data) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ],
      dataFileDinhKem: data
    });
    this.handleChangeData();
    //
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.handleChangeData();
  }

  saveGiaiQuyetDon(params, message) {
    GiaiQuyetDonThu.actions.updateGiaiQuyetDon.request({id: this.state.data.thongTinGiaiQuyetDonId},params).then(res => {
      this.onClickClose();
      Toastr(message ? msg[message] : msg.luuGiaiQuyetDonThanhCong, 'success');
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }


  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  onClickClose() {
    browserHistory.goBack();
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({...this.state});
  }

  handleBack(allowBack) {
    if (allowBack) {
      browserHistory.goBack();
    } else {
      if (this.state.hasChange) {
        this.setState({backConfirm: true});
      } else {
        browserHistory.goBack();
      }
    }
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    })
  }

  handleSave() {
    if(this.validateSubmitForm()) {
      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      this.state.dataFileDinhKem.map((item, i) => {
        if (item.duongDan == '') {
          // DO nothing
        } else if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(this.state.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            don: {
              id: Number(this.state.id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: loaiTepDinhKem,
            buocGiaiQuyet: buocGiaiQuyet,
            loaiQuyTrinh: loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      if(this.state.taiLieuVanThu.length > 0) {
        let params = {
          taiLieuVanThus: this.state.taiLieuVanThu
        }
        this.postTaiLieuVanThu(params);
      }

      if(this.state.taiLieuVanThuUpdate.length > 0) {
        let params = {
          taiLieuVanThus: this.state.taiLieuVanThuUpdate
        }
        this.updateTaiLieuVanThu(params);
      }

      if(this.state.taiLieuVanThuDelete.length > 0) {

        let params = {
          taiLieuVanThus: this.state.taiLieuVanThuDelete
        }
        this.deleteTaiLieuVanThu(params);
      }

      let params = getParams(this.state.dataLichSuGiaiQuyet.thongTinGiaiQuyetDonInfo, this.state.id);
      params.noiDungBoSungHoSo = this.state.noiDungBoSungHoSo;

      this.saveGiaiQuyetDon(params, 'gqdLuu');
    }
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
    this.handleChangeData();
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  render() {
    return (
      <div className="center">
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <div className="back-foward">
          <Link onClick={ this.handleBack.bind(this, false) } title="">Về trang trước</Link>
        </div>
        <div className="heading">
          <h2 className="heading-title icon-detail">Thông tin giải quyết đơn/vụ việc</h2>
        </div>
        <div className="page-wrapper">
          <ChiTietDon isOpen={this.state.isOpen} donId={this.state.id} loaiDon={this.state.loaiDon} dataGiaiQuyet={this.state.dataLichSuGiaiQuyet} data={this.state.data}/>
          <ShowIf condition={this.state.hideQuaTrinhXuLy != true}>
            <QuaTrinhXuLy parents={this}/>
          </ShowIf>
        </div>
        {
          !this.state.hideKetQuaXuLyDon ?
            <div className="page-wrapper">
              <KetQuaXuLyDon donInfo = {this.state.data} status={this.state.hideKetQuaXuLyDon} {...this.state.dataKetQuaXuLyDon} dataGiaiQuyet={this.state.dataLichSuGiaiQuyet}/>
            </div>
          :null
        }
        <div className="page-wrapper">
          {this.state.formGiaiQuyet}
        </div>
        <div className="page-wrapper mb30">
          <h2 className="title-14 mb15">Bổ sung thông tin</h2>
          <div className="row pl10 pr10">
            <TextArea value={this.state.noiDungBoSungHoSo} bindValidator={this} channel="formTaoDon" require className="areal-wrap col-100" label="Lý do bổ sung" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'noiDungBoSungHoSo')} name="" maxLength={1000} />
            <ShowIf condition={this.state.showAttachFile}>
              <div className="col-100 pb5">
                <ContainerFileDinhKem onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuBoSungHoSo} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
          </div>
          <ShowIf condition={this.props.lanhDao != true}>
            <div className="box-bottom">
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.handleBack.bind(this, false)}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
            </div>
          </ShowIf>
        </div>

        <ShowIf condition={this.props.lanhDao == true}>
          <div className="box-bottom pt10 mb40">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.handleBack.bind(this, false)}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
          </div>
        </ShowIf>
      </div>
    );
  }
}

BoSungThongTin.defaultProps = {
  lanhDao: false,
  validators: {
    formTaoDon: []
  }
}

export default BoSungThongTin;



// WEBPACK FOOTER //
// ./src/components/modules/bo-sung-thong-tin/BoSungThongTin.jsx